import "./init_glob";
import "./init_app.js";
import "./modals.js";
import "./accordions.js";
import "./sendMail.js";
// import "../helpers/spreadsheet.js";

import { createObserver } from "../helpers/observer.js";
import { calculator } from "./calculator.js";
import { debounce } from "../helpers/debounce.js";
import { initOpenMenuBtnsListeners } from "./initListeners.js";

const debouncedCalculator = debounce(calculator, 100);
servObj.calcObserver = createObserver(servObj.calc, debouncedCalculator);

initOpenMenuBtnsListeners();

function toggleFullscreen() {
    const isMobile = window.innerWidth < 1024;
    const isLandscape = window.matchMedia("(orientation: landscape)").matches;

    // Получаем текущий элемент в полноэкранном режиме
    const fsElement = document.fullscreenElement;

    // Если во весь экран открыт IFRAME или видео-модалка,
    // мы просто выходим из этой функции и ничего не ломаем.
    if (fsElement && (fsElement.tagName === "IFRAME" || fsElement.closest("#video_modal"))) {
        return;
    }

    // Проверяем условия
    if (isMobile && isLandscape) {
        const docEl = document.documentElement;

        if (!document.fullscreenElement) {
            // Входим в полноэкранный режим
            docEl.requestFullscreen().catch((err) => {
                console.error(`Ошибка: ${err.message}`);
            });
        }
    } else {
        // Выходим только если полноэкранным является сам документ (html),
        // а не сторонний плеер
        if (fsElement === document.documentElement) {
            document.exitFullscreen();
        }
    }
}

// Слушаем клик и изменение ориентации
window.addEventListener("click", toggleFullscreen);
document.querySelector("canvas")?.addEventListener("click", toggleFullscreen);
window.addEventListener("resize", toggleFullscreen);
